export type AdminUserRole = {
    roleName: string;
    isReadOnly: boolean;
};

export type AdminUser = {
    userId: number;
    username: string | null;
    email: string | null;
    roles: AdminUserRole[];
};

export type GrantRoleRequest = {
    userId: number;
    roleName: string;
    isReadOnly: boolean;
};

export type RevokeRoleRequest = {
    userId: number;
    roleName: string;
};

export type FeatureFlagRoleBinding = {
    featureFlagId: number;
    featureName: string;
    isEnabledGlobally: boolean;
    boundRoles: string[];
};

// Content_Generator is intentionally excluded — TBD and not assignable in production (see docs/RBAC.md).
export const ASSIGNABLE_ROLES = ["Player", "Analyst", "Sporting Director", "Admin"] as const;
